import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SvgIcon, Typography } from '@mui/material';

import LocationStopV2Icon from '@mopla/ui/icons/LocationStopV2.svg';
import WalkingFilled from '@mopla/ui/icons/WalkingFilled.svg';

import { DetailTextStyled, TransportCardInfoSubtitle } from './styled';

interface IBookingRouteSummaryProps {
	transfersCount: number;
	stopsCount: number;
}

/** Collapsed description of what happens between the first and the last route stop */
export const BookingRouteSummary: FC<IBookingRouteSummaryProps> = ({
	transfersCount,
	stopsCount,
}) => {
	const { t } = useTranslation('common');

	return (
		<TransportCardInfoSubtitle>
			{transfersCount > 0 && (
				<DetailTextStyled>
					<SvgIcon component={WalkingFilled} fontSize="xs" />
					<Typography variant="b2">
						{t('text.changes', { count: transfersCount })}
					</Typography>
				</DetailTextStyled>
			)}
			{stopsCount > 0 && (
				<DetailTextStyled>
					<SvgIcon component={LocationStopV2Icon} fontSize="xs" />
					<Typography variant="b2">
						{t('text.stops', { count: stopsCount })}
					</Typography>
				</DetailTextStyled>
			)}
		</TransportCardInfoSubtitle>
	);
};
